"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translate = _interopRequireDefault(require("../translate"));

var _projectLockView = _interopRequireDefault(require("../project-lock-view"));

var _authorisation = _interopRequireDefault(require("../authorisation"));

var _conf = _interopRequireDefault(require("../../conf"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _lockOperations = require("./lib/lock-operations");

var _resetSection = _interopRequireDefault(require("./lib/reset-section"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var LockBrunches = new _authorisation.default(['admin', 'projectresponsible'], ['brunch'], false)(_projectLockView.default);
var LockLockpfosten = new _authorisation.default(['admin', 'projectresponsible'], ['lockpfosten'], false)(_projectLockView.default);
var LockToh = new _authorisation.default(['admin', 'projectresponsible'], ['toh'], false)(_projectLockView.default);
var ResetSection = new _authorisation.default(['admin', 'projectresponsible'], ['lockpfosten', 'toh', 'brunch'], false)(_resetSection.default);

var ProjectResetContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(ProjectResetContainer, _React$Component);

  function ProjectResetContainer(props) {
    var _this;

    _classCallCheck(this, ProjectResetContainer);

    _this = _possibleConstructorReturn(this, (ProjectResetContainer.__proto__ || Object.getPrototypeOf(ProjectResetContainer)).call(this, props));
    _this.state = {
      loading: false,
      lockpfostenIsLocked: false,
      brunchIsLocked: false,
      tohIsLocked: false
    };
    _this.topMessage = _this.topMessage.bind(_assertThisInitialized(_this));
    _this.requestBrunchResetProjectRegistration = _this.requestBrunchResetProjectRegistration.bind(_assertThisInitialized(_this));
    _this.requestLockpfostenResetProjectRegistration = _this.requestLockpfostenResetProjectRegistration.bind(_assertThisInitialized(_this));
    _this.requestTohResetProjectRegistration = _this.requestTohResetProjectRegistration.bind(_assertThisInitialized(_this));
    _this.createBrunchLock = _this.createBrunchLock.bind(_assertThisInitialized(_this));
    _this.createLockpfostenLock = _this.createLockpfostenLock.bind(_assertThisInitialized(_this));
    _this.createTohLock = _this.createTohLock.bind(_assertThisInitialized(_this));
    _this.freeBrunchLock = _this.freeBrunchLock.bind(_assertThisInitialized(_this));
    _this.freeLockpfostenLock = _this.freeLockpfostenLock.bind(_assertThisInitialized(_this));
    _this.freeTohLock = _this.freeTohLock.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ProjectResetContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkBrunchLock();
      this.checkLockpfostenLock();
      this.checkTohLock();
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("article", {
        className: 'comp-project-reset-container'
      }, this.topMessage(), /*#__PURE__*/_react.default.createElement("section", {
        className: 'project-lock-section'
      }, /*#__PURE__*/_react.default.createElement("h2", null, t('Lock projects')), /*#__PURE__*/_react.default.createElement(LockBrunches, {
        title: this.state.brunchIsLocked ? t('Unlock brunch registrations') : t('Lock brunch registrations'),
        description: this.state.brunchIsLocked ? t('locked description') : t('unlocked description'),
        buttonText: this.state.brunchIsLocked ? t('unlock button') : t('lock button'),
        buttonOperation: this.state.brunchIsLocked ? this.freeBrunchLock : this.createBrunchLock
      }), /*#__PURE__*/_react.default.createElement(LockLockpfosten, {
        title: this.state.lockpfostenIsLocked ? t('Unlock lockpfosten registrations') : t('Lock lockpfosten registrations'),
        description: this.state.lockpfostenIsLocked ? t('locked description') : t('unlocked description'),
        buttonText: this.state.lockpfostenIsLocked ? t('unlock button') : t('lock button'),
        buttonOperation: this.state.lockpfostenIsLocked ? this.freeLockpfostenLock : this.createLockpfostenLock
      }), /*#__PURE__*/_react.default.createElement(LockToh, {
        title: this.state.tohIsLocked ? t('Unlock toh registrations') : t('Lock toh registrations'),
        description: this.state.tohIsLocked ? t('locked description') : t('unlocked description'),
        buttonText: this.state.tohIsLocked ? t('unlock button') : t('lock button'),
        buttonOperation: this.state.tohIsLocked ? this.freeTohLock : this.createTohLock
      })), /*#__PURE__*/_react.default.createElement(ResetSection, {
        t: t,
        requestBrunchResetProjectRegistration: this.requestBrunchResetProjectRegistration,
        requestLockpfostenResetProjectRegistration: this.requestLockpfostenResetProjectRegistration,
        requestTohResetProjectRegistration: this.requestTohResetProjectRegistration
      }));
    }
  }, {
    key: "topMessage",
    value: function topMessage() {
      var t = this.props.t;
      if (!this.state.success && this.state.error) return /*#__PURE__*/_react.default.createElement("div", {
        "data-abide-error": true,
        role: "alert",
        className: "alert callout"
      }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("i", {
        className: "fi-warning"
      }), t(this.state.error)));else if (this.state.success) return /*#__PURE__*/_react.default.createElement("div", {
        className: "success callout",
        "data-closable": "slide-out-right"
      }, /*#__PURE__*/_react.default.createElement("p", null, t('The operation was completed successfully')));
    }
  }, {
    key: "requestBrunchResetProjectRegistration",
    value: function requestBrunchResetProjectRegistration() {
      return fetch(_conf.default.api.brunchResetApiUrlTemplate(this.props.i18n.language), {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      }).then(_fetchUtils.default.checkStatus).catch(function (err) {
        void 0;
        return Promise.reject(err);
      });
    }
  }, {
    key: "requestLockpfostenResetProjectRegistration",
    value: function requestLockpfostenResetProjectRegistration() {
      return fetch(_conf.default.api.lockpfostenResetApiUrlTemplate(this.props.i18n.language), {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      }).then(_fetchUtils.default.checkStatus).catch(function (err) {
        void 0;
        return Promise.reject(err);
      });
    }
  }, {
    key: "requestTohResetProjectRegistration",
    value: function requestTohResetProjectRegistration() {
      return fetch(_conf.default.api.tohResetApiUrlTemplate(this.props.i18n.language), {
        method: 'PUT',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      }).then(_fetchUtils.default.checkStatus).catch(function (err) {
        void 0;
        return Promise.reject(err);
      });
    }
  }, {
    key: "checkBrunchLock",
    value: function checkBrunchLock() {
      var _this2 = this;

      (0, _lockOperations.checkLock)('brunch', _fetchUtils.default, _conf.default).then(function (result) {
        _this2.setState({
          brunchIsLocked: result.lock === 'project_locked'
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "freeBrunchLock",
    value: function freeBrunchLock() {
      var _this3 = this;

      (0, _lockOperations.removeLock)('brunch', _fetchUtils.default, _conf.default).then(function () {
        _this3.setState({
          brunchIsLocked: false
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "createBrunchLock",
    value: function createBrunchLock() {
      var _this4 = this;

      (0, _lockOperations.createLock)('brunch', _fetchUtils.default, _conf.default).then(function () {
        _this4.setState({
          brunchIsLocked: true
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "checkLockpfostenLock",
    value: function checkLockpfostenLock() {
      var _this5 = this;

      (0, _lockOperations.checkLock)('lockpfosten', _fetchUtils.default, _conf.default).then(function (result) {
        _this5.setState({
          lockpfostenIsLocked: result.lock === 'project_locked'
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "freeLockpfostenLock",
    value: function freeLockpfostenLock() {
      var _this6 = this;

      (0, _lockOperations.removeLock)('lockpfosten', _fetchUtils.default, _conf.default).then(function () {
        _this6.setState({
          lockpfostenIsLocked: false
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "createLockpfostenLock",
    value: function createLockpfostenLock() {
      var _this7 = this;

      (0, _lockOperations.createLock)('lockpfosten', _fetchUtils.default, _conf.default).then(function () {
        _this7.setState({
          lockpfostenIsLocked: true
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "checkTohLock",
    value: function checkTohLock() {
      var _this8 = this;

      (0, _lockOperations.checkLock)('toh', _fetchUtils.default, _conf.default).then(function (result) {
        _this8.setState({
          tohIsLocked: result.lock === 'project_locked'
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "freeTohLock",
    value: function freeTohLock() {
      var _this9 = this;

      (0, _lockOperations.removeLock)('toh', _fetchUtils.default, _conf.default).then(function () {
        _this9.setState({
          tohIsLocked: false
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "createTohLock",
    value: function createTohLock() {
      var _this10 = this;

      (0, _lockOperations.createLock)('toh', _fetchUtils.default, _conf.default).then(function () {
        _this10.setState({
          tohIsLocked: true
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }]);

  return ProjectResetContainer;
}(_react.default.Component);

ProjectResetContainer.propTypes = {
  t: _propTypes.default.func,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  })
};

var _default = (0, _translate.default)(ProjectResetContainer);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/project-reset-container/index.js
// module id = 759
// module chunks = 0